module.exports = __webpack_public_path__ + "img/buzo.7a99144c.png";